/* agent-axios-interceptor.ts */

/* Cookies */
import Cookies from "js-cookie";

/* Environment */
const { VITE_AGENT_PREFIX } = import.meta.env;

/* Axios */
import axios, { AxiosInstance } from "axios";

/**
 * Axios instance for the insights-agent API.
 *
 * For local development, VITE_AGENT_PREFIX is set to
 * 'http://localhost:8005/api/v1'. Otherwise, the prefix is
 * set to '/agent' (hardcoded), which nginx proxies to the
 * insights-agent service.
 *
 * The agent validates the same Keycloak access token as the
 * insights-backend, so the existing access_token cookie is
 * attached as bearer token.
 **/

/* Interface */
import { TokenType } from "src/shared/interfaces/api/Token";

/* Utils */
import { mayReceiveToken } from "src/utils/helper/common/tokenTarget";

const agentBaseUrl = VITE_AGENT_PREFIX
  ? VITE_AGENT_PREFIX
  : "/agent";

/**
 * Evaluated once, because the base URL is a build-time constant: a build
 * pointed at a host other than this app's own must not take the user's
 * token with it.
 */
const agentMayReceiveToken = mayReceiveToken(agentBaseUrl);

const agentAxiosInterceptor: AxiosInstance = axios.create({
  baseURL: agentBaseUrl,
  // LLM answers can take longer than regular API calls
  timeout: 300000,
});

agentAxiosInterceptor.interceptors.request.use((config) => {
  const access_token = Cookies.get(TokenType.ACCESS_TOKEN);

  if (access_token && agentMayReceiveToken) {
    config.headers.Authorization = `Bearer ${access_token}`;
  }
  return config;
});

export default agentAxiosInterceptor;
